
import { Component, Vue } from 'vue-property-decorator'
import QueryString from 'query-string'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { ReporterService } from '@/services/index'

@Component({
    name: 'GroupsList',
    components: {
    }
})
export default class extends Vue {
    private name: string = ''
    private reporters = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = true

    private mounted() {
        const parsed: any = QueryString.parse(location.search)
        this.name = parsed.name
        this.getReporters()
    }

    private async getReporters() {
        const params = {
            name: this.name,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await ReporterService.getReportersByName(params)
        if (result.status === 200) {
            this.reporters = result.data.reporters
            this.pageTotal = result.data.page_total
        }
        this.loading = false
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getReporters()
        $backtop.scrollToTop()
    }
}
